module.exports = __webpack_public_path__ + "static/media/nav3.13752d7d.png";